import { useFormState, useWatch } from 'react-hook-form';
import { requiredOk } from '../../../utils';

export const useInsuranceProvider = (control) => {
  const watchedValues = useWatch({
    control,
    name: ['insurances'],
  });

  const { dirtyFields } = useFormState({ control });

  const formValues = {
    insurances: watchedValues[0],
  };

  const isValid = formValues.insurances?.length !== 0;
  const canSave = requiredOk(dirtyFields.insurances, isValid);

  return {
    formValues,
    isValid,
    canSave,
  };
};
